<template>
    <div v-show="false">
        <!-- <SidebarType1 v-if="generalSettings.sidebar_type === 'type1'"></SidebarType1> -->
        <!-- <SidebarType2 v-if="generalSettings.sidebar_type === 'type2'"></SidebarType2> -->
        <!-- <SidebarType3 v-if="generalSettings.sidebar_type === 'type3'"></SidebarType3> -->
        <SideFloatingBar />
    </div>
</template>

<script>
// import SidebarType1 from './SidebarType1';
// import SidebarType2 from './SidebarType2';
// import SidebarType3 from './SidebarType3';
import SideFloatingBar from './SidebarType3';
// import { mapGetters } from 'vuex';
export default {
    components: {
        // SidebarType1,
        // SidebarType2,
        // SidebarType3,
        SideFloatingBar,
    },
    computed: {
        // ...mapGetters('app', ['generalSettings']),
    },
    methods: {
        //
    },
    created() {
        // this.path = window.location.pathname;
    },
};
</script>
